// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bookyear-wrapper[data-v-683ecb7a]{\r\n\tmargin-left: 15px;\n}\n.sale-search-browse.w-container[data-v-683ecb7a]{ padding: 0 0 0 0;\n}\n*[data-v-683ecb7a] .actions{ margin-top: 0;\n}\n*[data-v-683ecb7a] .w-col.grow{ padding: 0 0 0 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
